import moment from "moment";
import { useEffect } from "react";
import secureLocalStorage from "react-secure-storage";

export const ProfilePicFolder = "profilePic";

// Firefox 1.0+
export const isFirefox = typeof InstallTrigger !== "undefined";

// Safari 3.0+ "[object HTMLElementConstructor]"
//export const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

/****Validate hastag
 * @param handtag - input hastag
 *  ********* */
export const validHashTag = (hastag) => {
  var pattern = /(#(?:[^\x00-\x7F]|\w)+)/g;
  return pattern.test(hastag);
};
/**** Local Image Path url
 * @param filePath - file pick by user
 */
export const localImageURL = (filePath) => {
  return URL.createObjectURL(filePath);
};

/****Generate Random String
 * @param length - length of string like 5 characters
 *  ********* */
export const generateAppID = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
/***Check valid json */
export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/***check valid number */
export const isValidNumber = (str) => {
  const pattern = /^[0-9\b]+$/;
  return pattern.test(str);
};

export const validEmail = (val) => {
  const pattern = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
  return pattern.test(val);
};
/***Create uniqueID */
export const uniqueId = (length = 16) => {
  return parseInt(
    Math.ceil(Math.random() * Date.now())
      .toPrecision(length)
      .toString()
      .replace(".", "")
  );
};

export const validYouTubeVimeoLink = (val) => {
  const pattern =
    /^(http\\:\/\/|https\\:\/\/)?((www\.)?(vimeo\.com\/)([0-9]+)$)|((www\.youtube\.com|youtu\.be)\/.+$)/;
  return pattern.test(val);
};
/**Conver html into plain string */
export const htmlToText = (val) => {
  return val.replace(/<[^>]+>/g, "");
};

export const validateEmpty = (str) => {
  return !str || str.length === 0;
};

//delete items from array
export const deleteItem = (itemData, idx) => {
  return itemData.filter((item) => item.uId !== idx);
};

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0;
};
// Capitalize the first letter of each part of the name
export const capitalizeName = (name) => {
  if (!name) return null;
  return name
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
};

export const debounce = (func, time) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, time);
  };
};

export const todayDate = () => {
  return moment(new Date()).format("yyyy-MM-DD");
};

export const currentTime = () => {
  return moment(new Date()).format("HH:mm");
};

export const selectValue = (data, value, isLabel) => {
  const valueIndex = data?.findIndex((item) => item.id === value);
  let valueAtIndex = "";
  if (isLabel) {
    valueAtIndex = data[valueIndex].label;
  }
  return isLabel ? valueAtIndex : valueIndex;
};

export const useOutsideAlerter = (ref, funCall) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        //setShowList(false);
        funCall();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

export const diffDays = (lastDate) => {
  var startDate = Date.parse(lastDate);
  var endDate = Date.parse(todayDate());
  var timeDiff = Math.abs(startDate - endDate);
  var result = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return result;
};

/**Convert date time according to event calender below format*
 * new Date(2023, 7, 2, 8, 30, 0),
 * @author : Expertinasia Pvt. Ltd.
 */
export const convertUTCToLocalTime = (eventDate) => {
  var localTime = moment.utc(eventDate).toDate();
  let day = moment(localTime, "YYYY/MM/DD").date();
  let month = moment(localTime, "YYYY/MM/DD").month();
  let year = moment(localTime, "YYYY/MM/DD").year();
  let hours = moment(localTime, "YYYY/MM/DD HH:mm").hours();
  let minutes = moment(localTime, "YYYY/MM/DD HH:mm").minutes();
  localTime = new Date(year, month, day, hours, minutes, 0);
  return localTime;
};

export const generateCrewRequired = (number) => {
  const crewRequired = [];
  for (let i = 1; i <= number; i++) {
    crewRequired.push({ id: i.toString(), name: i.toString() });
  }
  return crewRequired;
};

export function getMaxValue(value, limit) {
  const result = value / limit;
  return Math.max(1, Math.min(result, 2));
}

export function getTimeZone() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone;
}
// export function getCountryCode() {
//   const options = Intl.DateTimeFormat().resolvedOptions();
//   const tzMap = {
//     "Asia/Calcutta": "IN",
//     "Asia/Kolkata": "IN",
//     "Europe/London": "UK",
//     "America/New_York": "US",
//     "America/Sao_Paulo": "BR",
//   };

//   const countryCode = new Intl.Locale(options.locale).region;
//   return tzMap[options?.timeZone] || "IN";
// }
// utils/getCountryCode.js
export async function getCountryCode(userData) {
  // If coordinates are missing, fallback to AU
  if (
    !userData?.location?.coordinates ||
    userData.location.coordinates.length < 2
  ) {
    return "AU";
  }

  // GeoJSON style: [lng, lat]
  const [lng, lat] = userData?.location?.coordinates;

  try {
    const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`;
    const response = await fetch(url, {
      headers: { "User-Agent": "MyApp" },
    });
    const data = await response.json();

    if (data.address && data.address.country_code) {
      return data.address.country_code.toUpperCase(); // e.g., "IN", "AU"
    }

    return "AU"; // fallback
  } catch (err) {
    console.error("Error getting country code:", err);
    return "AU"; // fallback
  }
}

export function getCurrentCountryName() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const tzMap = {
    "Asia/Calcutta": "India",
    "Asia/Kolkata": "India",
    "Europe/London": "United Kingdom",
    "America/New_York": "United States",
    "America/Sao_Paulo": "Brazil",
  };

  return tzMap[timeZone] || "Unknown";
}

export function formatHourToTime(value) {
  const hour = parseInt(value, 10);
  return String(hour).padStart(2, "0") + ":00";
}

export function revertTimeToHour(timeString) {
  if (!timeString) return "";
  return parseInt(timeString.split(":")[0], 10).toString();
}

export function CurrencyFormat(value) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // India
  if (timezone === "Asia/Kolkata" || timezone === "Asia/Calcutta") {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(value);
  }

  // Australia
  if (timezone === "Australia/Sydney" || timezone.startsWith("Australia/")) {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      maximumFractionDigits: 2,
    }).format(value);
  }

  // Default (USD)
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(value);
}

function parseLocalDate(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function getDatesFromTodayToBookingPlus15(bookingDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const endDate = parseLocalDate(bookingDate);
  endDate.setHours(0, 0, 0, 0);
  endDate.setDate(endDate.getDate() + 15);

  const dates = [];
  let current = new Date(today);

  while (current <= endDate) {
    dates.push(formatDate(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

function formatDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export const formatChatTime = (timestamp) => {
  if (!timestamp) return "";

  // Firestore Timestamp → Date
  const date = timestamp.toDate
    ? timestamp.toDate()
    : new Date(timestamp.seconds * 1000);

  if (moment(date).isSame(moment(), "day")) {
    // Today → show time
    return moment(date).format("hh:mm A");
  }

  if (moment(date).isSame(moment().subtract(1, "day"), "day")) {
    // Yesterday
    return "Yesterday";
  }

  // Older → show date
  return moment(date).format("DD MMM YYYY");
};

export const getDateKey = (timestamp) => {
  if (!timestamp) return "unknown";

  const date = timestamp.toDate
    ? timestamp.toDate()
    : new Date(timestamp.seconds * 1000);

  return moment(date).format("YYYY-MM-DD");
};

export const getChatKey = (timestamp) => {
  if (!timestamp) return "unknown";

  const date = timestamp.toDate
    ? timestamp.toDate()
    : new Date(timestamp.seconds * 1000);

  return moment(date).format("hh:mm A");
};

export const getCurrentcoords = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (pos?.coords?.latitude && pos?.coords?.longitude) {
          const coords = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          resolve(coords); // Resolving the Promise with the coordinates
        }
      },
      (err) => {
        reject(err); // Handle error if geolocation fails
      }
    );
  });
};
export function stringToBoolean(value) {
  return value?.toLowerCase() === "true";
}

export function convertDateTimeUtc(date, time) {
  // Create Date object in local time
  const localDateTime = new Date(`${date}T${time}:00`);

  // Convert to UTC timestamp (milliseconds)
  const utcMillis = localDateTime.getTime();
  return utcMillis;
}

export function getSportsIcon(data, name) {
  const sportsObj = data?.find((item) => item?.name == name);
  return sportsObj ? sportsObj?.icon : "";
}

export const createUniqueId = (cardType) => {
  const timeStamp = Date.now(); // milliseconds since epoch
  return `${cardType}${timeStamp}`;
};
